export default __webpack_public_path__ + "static/media/language-icon.cd142b0a.svg";